import { removeSpinner } from './removeSpinner';

export function removeSpinnerWhenShouldBeautifyLink(
    shouldBeautifyLink: boolean,
    linkIdsWithSpinner: string[],
    anchorElement: HTMLAnchorElement,
    addedElements: Node[]
) {
    if (shouldBeautifyLink) {
        const index = linkIdsWithSpinner.indexOf(anchorElement.id);
        linkIdsWithSpinner.splice(index, 1);
        removeSpinner(anchorElement, addedElements);
    }
}
